<template>
  <div class="payment-schedule secondary" ref="paymentSchedule">
    <div class="section-header">
      <v-layout row>
        <v-flex lg9>
          <div class="section-name">{{ layoutSetting.section.caption }}</div>
          <span class="p-l-10" v-if="loan.phase === dataType.LoanPhaseEnum.LOAN_ORIGINATION.value">
              <span class="text-success"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Regular Amount</span></span>
              <span class="text-danger p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Irregular Amount</span></span>
          </span>
          <span class="p-l-10" v-if="$route.path.includes(dataType.LoanPhaseEnum.PAYMENT_PROCESSING.abbr) || $route.path.includes(dataType.LoanPhaseEnum.LOAN_COLLECTION.abbr)">
              <span class="text-blue p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">New</span></span>
              <span class="text-orange p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Not Checked/Partial Makeup/Unknown</span></span>
              <span class="text-success p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Checked</span></span>
              <span class="text-danger p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Rejected/Skip/Refunded</span></span>
              <span class="text-grey-500 p-l-5"><i class="fas fa-square"></i><span class="f-s-10 p-l-5">Deleted</span></span>
          </span>
        </v-flex>
        <v-flex lg3>
          <div class="section-action" @mouseover="showTooltip">
            <v-tooltip bottom v-if="($route.path.includes(dataType.LoanPhaseEnum.PAYMENT_PROCESSING.abbr) || $route.path.includes(dataType.LoanPhaseEnum.LOAN_COLLECTION.abbr)) &&
            isShowElement(privileges, dataType.PrivilegeCode.CANCEL_CHANGES, dataType.PrivilegeType.EXECUTABLE) && isNotExternal()">
              <template
                v-slot:activator="{ on }"
              >
                <v-btn
                  color="primary"
                  dark
                  tile
                  small
                  slot="activator"
                  class="btn-action width-30 m-r-10"
                  v-on="on"
                  @click="triggerCancelChanges(true)"
                >
                  <v-icon style="margin-top: -4px !important;">settings_backup_restore</v-icon>
                </v-btn>
              </template>
              <span>Cancel Changes</span>
            </v-tooltip>
            <v-tooltip left max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <i class="fad fa-lightbulb text-warning" v-bind="attrs" v-on="on"></i>
              </template>
              <div v-html="toolTipData"></div>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="section-table" ref="sectionTable">
      <arb-simple-table
        :desserts="installments"
        :header="layoutSetting.sectionFields"
        :height="tableHeight"
        :color="$vuetify.theme.themes.light.secondary"
        :transactionProviderList="transactionProviderList"
        :hasCreditAction="hasCreditAction"
      ></arb-simple-table>
    </div>
    <!-- end table-responsive -->
    <!-- begin payment-amount -->
    <div class="payment-amount" ref="paymentAmount" v-if="loan.phase !== dataType.LoanPhaseEnum.LOAN_COLLECTION.value">
      <div class="payment-amount-left" :class="`bg-${store.state.theme.colorText}-transparent-4`">
        <div class="payment-amount-row">
          <template v-for="(field, index) in layout.footerLayout.LEFT">
            <div class="sub-price" :key="renderTool.getRandomKey(index)">
              <small>{{ field.label }}</small>
              <span class="black--text">
                {{ renderTool.formatCurrencyWithFieldKey(paymentFeeData, field.fieldKey) }}
              </span>
            </div>
            <div class="sub-price" v-if="index < layout.footerLayout.LEFT.length - 1" :key="renderTool.getRandomKey(index)">
              <i class="fa fa-plus text-muted"></i>
            </div>
          </template>
        </div>
      </div>
      <div class="payment-amount-right">
        <small>{{ layout.footerLayout.RIGHT.label }}</small>
        <span class="f-w-600">
          {{ renderTool.formatCurrencyWithFieldKey(paymentFeeData, layout.footerLayout.RIGHT.fieldKey) }}
        </span>
      </div>
    </div>
    <v-dialog v-model="dialog.display" max-width="400px" persistent>
      <payment-schedule-action-card
        v-if="dialog.display && isShowElement(privileges, dialog.setting.privilegeCode, dataType.PrivilegeType.EXECUTABLE)"
        v-model="dialog.data"
        :returnCodeArr="returnCodeArr"
        :setting="dialog.setting"
        :loan="loan"
        :hideAction="hideDialog"
        :saveAction="saveActionEventHandler"
      ></payment-schedule-action-card>
    </v-dialog>
    <v-dialog v-model="cancelChangesDialog" persistent max-width="1000px">
      <cancel-changes-dialog
        :loan="loan"
        :display="cancelChangesDialog"
        @hideDialog="triggerCancelChanges(false)"
      ></cancel-changes-dialog>
    </v-dialog>
  </div>
</template>

<script>
import { ProcessingApi, OriginationApi, CollectionApi, MetaDataApi, PaymentApi } from '@/api/pandaria'
import { Authentication, DataType, Tool } from '@/util/index'
import { SystemEnum } from '@/assets/js'
import { PPS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/post-origination/dialog'
import { PPS_DETAIL_LAYOUT_SETTING } from '@/setting/layout/post-origination/detail'
import { LCS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/collection/dialog'
import PaymentScheduleActionCard from '@/components/panda/post-origination/dialog/PaymentScheduleActionCard'
import CancelChangesDialog from '../dialog/CancelChangesDialog'
const tool = new Tool()
export default {
  name: 'loan-detail-payment-schedule',
  components: {
    CancelChangesDialog,
    PaymentScheduleActionCard
  },
  props: {
    layoutSetting: Object,
    loan: Object,
    height: Number,
    privileges: {
      type: Array,
      default: () => []
    },
    installmentData: {
      type: Object,
      default: () => {}
    },
    toolTipData: String,
    slaveLoanId: Number,
    slaveLoan: Object,
    currentLocked: Number
  },
  data () {
    return {
      installments: [],
      paymentFeeData: {
        principal: '',
        interest: '',
        lateFee: ''
      },
      dataType: DataType,
      renderTool: tool,
      tableHeight: 200,
      layout: {
        footerLayout: PPS_DETAIL_LAYOUT_SETTING.PAYMENT_AMOUNT
      },
      dialog: {
        display: false,
        title: '',
        data: {},
        setting: []
      },
      cancelChangesDialog: false,
      currentLockedId: this.currentLocked,
      currentLoanId: null,
      regularAmount: '',
      returnCodeArr: [],
      transactionProviderList: []
    }
  },
  computed: {
    hasCreditAction () {
      let result = false
      if (
        this.isShowElement(
          this.privileges,
          DataType.PrivilegeCode.MANUAL_CHECKED_FOR_CREDIT,
          DataType.PrivilegeType.EXECUTABLE
        )
      ) {
        const loan = this.loan
        const installments = this.installments
        if (
          tool.isNotEmpty(loan) &&
          tool.isNotEmpty(installments) &&
          tool.isNotEmpty(installments[0])
        ) {
          const loanType = loan.loanType
          if (loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
            result =
              this.$store.getters.getCurrentLoan.loanStatus ===
              DataType.LoanStatus.NEW.value &&
              (installments[0].transactionStatus ===
                DataType.TransactionStatusEnum.NOT_CHECKED.value ||
                installments[0].transactionStatus ===
                DataType.TransactionStatusEnum.UNKNOWN.value)
          } else {
            result =
              this.loan.loanStatus === DataType.LoanStatus.NEW.value &&
              (installments[0].transactionStatus ===
                DataType.TransactionStatusEnum.NOT_CHECKED.value ||
                installments[0].transactionStatus ===
                DataType.TransactionStatusEnum.UNKNOWN.value)
          }
        }
      }
      return result
    }
  },
  watch: {
    async loan (val) {
      if (
        val.loanType !== DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value &&
        this.$route.path.includes(SystemEnum.ROUTER_PATH.PRE_ORIGINATION.prefix)
      ) {
        this.loadPaymentScheduleData(val.id)
        this.getPaymentFee(val.id)
      }
      if (
        this.$route.path.includes(
          SystemEnum.ROUTER_PATH.POST_ORIGINATION.prefix
        ) ||
        this.$route.path.includes(SystemEnum.ROUTER_PATH.COLLECTION.prefix)
      ) {
        await this.listTransactionProvider()
      }
    },
    slaveLoanId (val) {
      if (
        this.loan.loanType ===
        DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value &&
        this.$route.path.includes(SystemEnum.ROUTER_PATH.PRE_ORIGINATION.prefix)
      ) {
        this.loadPaymentScheduleData(val)
        this.getPaymentFee(val)
      }
    },
    height (val) {
      this.tableHeight = val - 135
    },
    toolTipData (val) {
      this.toolTipData = val
    },
    installmentData (val) {
      if (tool.isNotEmpty(val)) {
        this.regularAmount = val.regularAmount
        this.installments = val.installmentList
        this.colorPaymentScheduleRow(val.installmentList)
        this.paymentFeeData = {
          principal: val.totalPrincipal,
          interest: val.totalInterest,
          unpaidFee: val.totalUnpaidFee,
          amount: val.totalAmount
        }
      } else {
        this.installments = []
        this.paymentFeeData = {}
      }
      this.store.commit('setLoan', {
        loan: { paymentProgress: { totalAmount: this.paymentFeeData.amount } }
      })
    }
  },
  mounted () {
    this.$eventBus.$on('get-clicked-slave-detail-event', (target) => {
      this.installments = []
      this.currentLoanId = target.loanId
      this.loadPaymentScheduleData(target.loanId)
      this.getPaymentFee(target.loanId)
    })
    this.$eventBus.$on('get-loan-detail-event', (target) => {
      this.installments = []
      this.currentLoanId = target.loanId
      this.loadPaymentScheduleData(target.loanId)
      this.getPaymentFee(target.loanId)
    })
    this.$eventBus.$on('broadcastLockedId', (target) => {
      this.currentLockedId = target
    })
  },
  methods: {
    async listTransactionProvider () {
      const $this = this
      $this.transactionProviderList = []
      const requestData = {
        portfolioId: $this.loan.portfolioId
      }
      await MetaDataApi.listTransactionProvider(requestData, function (result) {
        $this.transactionProviderList = result
      })
    },
    async getPaymentFee (loanId) {
      const $this = this
      const paymentFeeRequest = {
        loanId: loanId,
        typeList: [DataType.PaymentFeeTypeEnum.TOTAL.value]
      }
      if (tool.isNotEmpty(loanId)) {
        await ProcessingApi.getPaymentFeeData(
          paymentFeeRequest,
          function (result) {
            if (tool.isNotEmpty(result)) {
              $this.paymentFeeData =
                result[DataType.PaymentFeeTypeEnum.TOTAL.value]
            } else {
              $this.paymentFeeData = {}
            }
            $this.store.commit('setLoan', {
              loan: {
                paymentProgress: { totalAmount: $this.paymentFeeData.amount }
              }
            })
          }
        )
      }
    },
    showTooltip () {
      this.$eventBus.$emit('showTooltips', 'FOLLOWED_ACH_DISCLOSURE')
    },
    async clickActionEventHandler (changeType, fieldItem) {
      if (
        tool.isNotEmpty(this.store.getters.getFirstCreditDate) &&
        tool.isNotEmpty(this.store.getters.getNextBusinessDay)
      ) {
        this.dialog.setting = []
        this.dialog.data = JSON.parse(JSON.stringify(fieldItem))
        const firstCreditDate = this.store.getters.getFirstCreditDate.toString()
        const nextBusinessDate = this.store.getters.getNextBusinessDay.toString()
        if (new Date(firstCreditDate).getTime() >= new Date(nextBusinessDate).getTime()) {
          this.dialog.data.transactionDate = firstCreditDate
        } else {
          this.dialog.data.transactionDate = nextBusinessDate
        }
        switch (changeType) {
          case DataType.PaymentScheduleAction.ASSIGNED_MODE.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_MODE
            break
          case DataType.PaymentScheduleAction.ASSIGNED_DATE.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_DATE
            break
          case DataType.PaymentScheduleAction.ASSIGNED_AMOUNT.value:
            this.store.commit('setPPSSinglePSActionInterest', fieldItem.maxInterest)
            if (this.$route.path.includes('/post-origination/application/')) {
              this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_AMOUNT
            } else if (this.$route.path.includes('/collection/application/')) {
              this.dialog.setting = LCS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_AMOUNT
            }
            break
          case DataType.PaymentScheduleAction.ASSIGNED_SKIP.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_SKIP
            break
          case DataType.PaymentScheduleAction.MANUAL_REJECT.value:
            if (fieldItem?.transactionMode === DataType.TransactionModeEnum.WAGE_ASSIGMENT.value) {
              this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.MANUAL_REJECT_FOR_WA
            } else {
              await this.loadReturnCodeByAchProviderId(
                fieldItem.transactionProvider
              )
              this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.MANUAL_REJECT
            }

            break
          case DataType.PaymentScheduleAction.MANUAL_CHECKED.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.MANUAL_CHECKED
            break
          case DataType.PaymentScheduleAction.ASSIGNED_MAKEUP.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_MAKEUP
            break
          case DataType.PaymentScheduleAction.ASSIGNED_MAKEUP_PARTIAL.value:
            await this.loadMaxPartialAmount(fieldItem)
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.ASSIGNED_MAKEUP_PARTIAL
            break
          case DataType.PaymentScheduleAction.REFUND_PAYMENT.value:
            await this.loadRefundPaymentAmount(fieldItem)
            await this.loadMaxPartialBankFee(fieldItem)
            if (this.$route.path.includes('/collection/application/')) {
              this.dialog.setting = LCS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.REFUND_PAYMENT
            } else {
              this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.REFUND_PAYMENT
            }
            break
          case DataType.PaymentScheduleAction.REVERSE_DEBIT.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.REVERSE_DEBIT
            break
          case DataType.PaymentScheduleAction.CANCEL_CHANGE.value:
            this.dialog.setting = PPS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.CANCEL_CHANGE
            break
          case DataType.PaymentScheduleAction.COLLECTION_SINGLE_CANCEL.value:
            this.dialog.setting = LCS_DIALOG_LAYOUT_SETTING.SINGLE_PAYMENT_SCHEDULE_ACTION.CANCEL_CHANGE
            break
          default:
            break
        }
        this.dialog.display = tool.isNotEmpty(this.dialog.setting) && this.isLockedByCurrentUser()
      }
    },
    saveActionEventHandler (inputData, changeType) {
      const $this = this
      switch (changeType) {
        case DataType.PaymentScheduleAction.COLLECTION_SINGLE_CANCEL.value:
          CollectionApi.cancelOperation(
            inputData,
            function () {
              $this.singleOperationCallback(changeType)
            },
            this.singleOperationFailureBack
          )
          break
        case DataType.PaymentScheduleAction.CANCEL_CHANGE.value:
          ProcessingApi.cancelOperation(
            inputData,
            function () {
              $this.singleOperationCallback(changeType)
            },
            this.singleOperationFailureBack
          )
          break
        default:
          PaymentApi.singleOperation(
            inputData,
            function () {
              $this.singleOperationCallback(changeType)
            },
            this.singleOperationFailureBack
          )
          break
      }
    },
    singleOperationCallback (changeType) {
      if (
        this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value
      ) {
        switch (changeType) {
          case DataType.PaymentScheduleAction.ASSIGNED_SKIP.value:
            if (this.$route.path.includes('/collection/application/')) {
              this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: this.currentLoanId })
            } else {
              this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
            }
            break
          case DataType.PaymentScheduleAction.MANUAL_CHECKED.value:
          case DataType.PaymentScheduleAction.MANUAL_REJECT.value:
            this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
            break
          default:
            this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: this.currentLoanId })
            break
        }
      } else if (this.loan.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value) {
        this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: this.currentLoanId })
        this.$eventBus.$emit('get-installment-status-event', { loanId: this.currentLoanId })
      }
      this.hideDialog()
    },
    singleOperationFailureBack (err) {
      this.hideDialog()
      this.$popWarningAlert({ text: `${err.message}` })
    },
    hideDialog () {
      this.dialog.display = false
    },
    async loadReturnCodeByAchProviderId (transactionProvider) {
      const $this = this
      $this.returnCodeArr = []
      const data = { transactionProviderId: transactionProvider }
      await ProcessingApi.listReturnCode(
        data,
        function (data) {
          if (tool.isNotEmpty(data)) {
            $this.returnCodeArr = JSON.parse(data)
          }
        },
        function (err) {
          console.log(err)
        }
      )
    },
    async loadMaxPartialBankFee (fieldItem) {
      const $this = this
      $this.dialog.data.maxPartialBankFee = 0
      if (tool.isNotEmpty(fieldItem)) {
        const requestData = {
          id: fieldItem.id
        }
        await CollectionApi.getMaxPartialBankFee(
          requestData,
          function (result) {
            $this.dialog.data.maxPartialBankFee = result.amount
          }
        )
      }
    },
    async loadRefundPaymentAmount (fieldItem) {
      const $this = this
      $this.dialog.data.amount = 0
      if (tool.isNotEmpty(fieldItem)) {
        const requestData = {
          id: fieldItem.id
        }
        if ($this.$route.path.includes('/collection/application/')) {
          await CollectionApi.getMaxPartialAmount(
            requestData,
            function (result) {
              $this.dialog.data.amount = result.amount
            }
          )
        } else {
          await ProcessingApi.getMaxPartialAmount(
            requestData,
            function (result) {
              $this.dialog.data.amount = result
            }
          )
        }
      }
    },
    async loadMaxPartialAmount (fieldItem) {
      const $this = this
      $this.dialog.data.amount = 0
      $this.dialog.data.maxPartialAmount = 0
      if (tool.isNotEmpty(fieldItem)) {
        const requestData = {
          id: fieldItem.id
        }
        if ($this.$route.path.includes('/collection/application/')) {
          await CollectionApi.getMaxPartialAmount(
            requestData,
            function (result) {
              $this.dialog.data.amount = result.amount
              $this.dialog.data.maxPartialAmount = result.amount
            }
          )
        } else {
          await ProcessingApi.getMaxPartialAmount(
            requestData,
            function (result) {
              $this.dialog.data.amount = result
              $this.dialog.data.maxPartialAmount = result
            }
          )
        }
      }
    },
    loadPaymentScheduleData (loanId) {
      if (tool.isEmpty(loanId)) {
        return
      }
      const $this = this
      $this.regularAmount = ''
      this.store.commit('clearPaymentSchedule')
      const input = { loanId: loanId }
      PaymentApi.getPaymentInstallmentAndActionByLoanId(
        input,
        this.getPaymentInstallmentAndActionByLoanIdCallBack
      )
    },
    getPaymentInstallmentAndActionByLoanIdCallBack (result) {
      this.$eventBus.$emit('setPaymentSchedule', result)
      if (tool.isNotEmpty(result)) {
        this.store.commit('setHasPaymentSchedule', true)
        this.installments = result
        this.colorPaymentScheduleRow(result)
        this.$forceUpdate()
      }
    },
    async colorPaymentScheduleRow (installmentsData) {
      const $this = this
      $this.store.commit('setPaymentSchedule', installmentsData)
      if (
        tool.isEmpty($this.regularAmount) &&
        this.loan.phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value
      ) {
        const loanInStore = this.store.getters.getLoan
        const regularAmount = loanInStore.regularAmount
        if (tool.isEmpty(regularAmount)) {
          let loanId = this.loan.id
          if (
            this.loan.loanType ===
            DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value
          ) {
            loanId = this.slaveLoanId
          }
          await OriginationApi.getLoanFeatureData(
            loanId,
            'get',
            'payment-option',
            function (result) {
              $this.regularAmount = result.regularAmount
            }
          )
        } else {
          $this.regularAmount = regularAmount
        }
      }

      for (const installment of installmentsData) {
        if (this.loan.phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value) {
          this.colorOriginationPaymentScheduleRow(installment)
        } else {
          this.colorOtherPaymentScheduleRow(installment)
        }

        this.disablePaymentScheduleAction(installment)
      }
    },
    colorOriginationPaymentScheduleRow (installment) {
      if (
        installment.transactionType !== DataType.TransactionTypeEnum.CREDIT &&
        tool.isNotEmpty(this.regularAmount)
      ) {
        if (this.regularAmount === installment.amount) {
          // Regular Amount
          installment.class = 'bg-grey-transparent-1 text-green'
        } else {
          // Irregular Amount
          installment.class = 'bg-red-transparent-1 text-red'
        }
      }
    },
    colorOtherPaymentScheduleRow (installment) {
      const changeType = installment.changeType
        ? parseInt(installment.changeType)
        : 0
      const flags = installment.flags
      if (
        DataType.FlagsEnum.DELETED === (DataType.FlagsEnum.DELETED & flags) ||
        DataType.FlagsEnum.COLLECTION ===
        (DataType.FlagsEnum.COLLECTION & flags) ||
        this.isDeleteFlags(flags)
      ) {
        installment.class = 'bg-grey-transparent-1 text-grey'
      } else if (
        DataType.FlagsEnum.PARTIAL_MAKEUP ===
        (DataType.FlagsEnum.PARTIAL_MAKEUP & flags)
      ) {
        installment.class = 'bg-orange-transparent-1 text-orange'
      } else if (DataType.FlagsEnum.NEW === (DataType.FlagsEnum.NEW & flags)) {
        installment.class = 'bg-blue-transparent-2 text-blue'
        switch (installment.transactionStatus) {
          case DataType.TransactionStatusEnum.NOT_CHECKED.value:
          case DataType.TransactionStatusEnum.UNKNOWN.value:
            installment.class = 'bg-orange-transparent-1 text-orange'
            break
          case DataType.TransactionStatusEnum.CHECKED.value:
            if (
              (installment.flags & DataType.FlagsEnum.FULL_REFUNDED) ===
              DataType.FlagsEnum.FULL_REFUNDED ||
              (installment.flags & DataType.FlagsEnum.PARTIAL_REFUND) ===
              DataType.FlagsEnum.PARTIAL_REFUND
            ) {
              installment.class = 'bg-red-transparent-1 text-red'
            } else {
              installment.class = 'bg-green-transparent-1 text-green'
            }
            break
          case DataType.TransactionStatusEnum.REJECTED.value:
            installment.class = 'bg-red-transparent-1 text-red'
            break
          default:
            switch (changeType) {
              case DataType.ChangeTypeEnum.ASSIGNED_SKIP.value:
                installment.class = 'bg-red-transparent-1 text-red'
                break
            }
            break
        }
      } else {
        switch (installment.transactionStatus) {
          case DataType.TransactionStatusEnum.NOT_CHECKED.value:
          case DataType.TransactionStatusEnum.UNKNOWN.value:
            installment.class = 'bg-orange-transparent-1 text-orange'
            break
          case DataType.TransactionStatusEnum.CHECKED.value:
            if (
              installment.flags === DataType.FlagsEnum.FULL_REFUNDED ||
              installment.flags === DataType.FlagsEnum.PARTIAL_REFUND
            ) {
              installment.class = 'bg-red-transparent-1 text-red'
            } else {
              installment.class = 'bg-green-transparent-1 text-green'
            }
            break
          case DataType.TransactionStatusEnum.REJECTED.value:
            installment.class = 'bg-red-transparent-1 text-red'
            break
          default:
            switch (changeType) {
              case DataType.ChangeTypeEnum.ASSIGNED_SKIP.value:
                installment.class = 'bg-red-transparent-1 text-red'
                break
            }
            break
        }
      }
      if (DataType.ChangeTypeEnum.PAY_OFF.value === changeType) {
        this.store.commit('setPPSMultiPayOff', changeType)
      }
    },
    isDeleteFlags (flags) {
      if (
        flags === (DataType.FlagsEnum.DEFAULT ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.DELETED ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.FULL_REFUNDED ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.CANCEL ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.COLLECTION ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.PARTIAL_REFUND ^ (1 << 9)) ||
        flags === (DataType.FlagsEnum.NEW ^ (1 << 9))
      ) {
        return true
      }
    },
    disablePaymentScheduleAction (installment) {
      const actionList = []
      if (this.renderTool.isNotEmpty(installment.action)) {
        for (const item of installment.action) {
          const actionArr = Object.entries(item)[0]
          actionList.push({
            text: actionArr[0],
            value: actionArr[1],
            click: (fieldItem) => {
              this.clickActionEventHandler(actionArr[1], fieldItem)
            }
          })
        }
      }
      if (tool.isNotEmpty(actionList)) {
        installment.action = { disabled: false, actionList: actionList }
      } else {
        installment.action = { disabled: true, actionList: null }
      }
    },
    matchUserPrivilege (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    isShowElement (privileges, code, value) {
      return (
        this.matchUserPrivilege(privileges, code, value) &&
        Authentication.isLockedByCurrentUser(
          this.store.getters.getAccount,
          this.currentLockedId
        )
      )
    },
    isLockedByCurrentUser () {
      return Authentication.isLockedByCurrentUser(
        this.store.getters.getAccount,
        this.currentLockedId
      )
    },
    isValidStatus () {
      return (
        tool.isNotEmpty(this.slaveLoan) &&
        (this.slaveLoan.loanStatus ===
          DataType.LoanStatus.IN_HOUSE_REPLAN.value ||
          this.slaveLoan.loanStatus ===
          DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value)
      )
    },
    triggerCancelChanges (flag) {
      this.cancelChangesDialog = flag
      if (!flag) {
        this.loadPaymentScheduleData(this.currentLoanId)
        this.getPaymentFee(this.currentLoanId)
      }
    },
    isNotExternal () {
      const externalEum = [
        DataType.LoanStatus.PENDING_OUT_HOUSE_COLLECTION.value,
        DataType.LoanStatus.OUT_HOUSE_COLLECTION.value,
        DataType.LoanStatus.OUT_HOUSE_POCKETED.value,
        DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value,
        DataType.LoanStatus.OUT_HOUSE_CHARGE_OFF.value,
        DataType.LoanStatus.OUT_HOUSE_REJECTED.value,
        DataType.LoanStatus.OUT_HOUSE_SETTLEMENT_QUEUE.value,
        DataType.LoanStatus.OUT_HOUSE_SETTLEMENT.value
      ]
      return !externalEum.includes(this.loan.loanStatus)
    }
  }
}
</script>

<style lang="css" scoped>
.payment-schedule {
  background: #f5f5f5;
  padding: 20px 20px 0 20px;
  margin-top: 0 !important;
}

.payment-schedule .section-header {
  margin-bottom: -15px;
  padding-top: 12px;
}

.payment-schedule .section-header .flex {
  padding: 0 12px !important;
  white-space: nowrap;
}

.payment-schedule .section-name {
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  display: inline-block;
}

.payment-schedule .section-action {
  text-align: right;
  font-size: 14px;
}

.payment-schedule .section-table {
  margin-top: 10px;
}

.payment-amount {
  display: table;
  margin-left: -20px;
  margin-right: -20px;
  width: calc(100% + 40px);
}

.payment-amount .payment-amount-left,
.payment-amount .payment-amount-right {
  display: table-cell;
  padding: 15px;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  vertical-align: middle;
}
.payment-amount .payment-amount-left {
  width: 75%;
}
.payment-amount .payment-amount-left .sub-price {
  display: table-cell;
  vertical-align: middle;
  padding: 0 15px;
}
.payment-amount small {
  font-size: 13px;
  font-weight: normal;
  display: block;
  color: #818181;
}
.payment-amount .payment-amount-row {
  display: table;
  float: left;
}
.payment-amount .payment-amount-right {
  width: 25%;
  background: #212121;
  color: #fff;
  font-size: 23px;
  text-align: right;
  vertical-align: bottom;
  font-weight: 300;
}
.payment-amount .payment-amount-right small {
  display: block;
  opacity: 0.6;
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 13px;
  font-weight: 600;
}
.payment-schedule .section-action i {
  margin-top: -20px;
}
</style>
